import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  id: PropTypes.string,
};

const DoubleColumnGrid = ({
  color = '#B5BCBD',
  size = 18,
  id = 'double-column-grid',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M7.105 9.474c.785 0 1.421.636 1.421 1.42v5.685c0 .785-.636 1.421-1.42 1.421H1.42A1.421 1.421 0 0 1 0 16.579v-5.684c0-.785.636-1.421 1.421-1.421h5.684zm9.474 0c.785 0 1.421.636 1.421 1.42v5.685c0 .785-.636 1.421-1.421 1.421h-5.684a1.421 1.421 0 0 1-1.421-1.421v-5.684c0-.785.636-1.421 1.42-1.421h5.685zM7.105 0c.785 0 1.421.636 1.421 1.421v5.684c0 .785-.636 1.421-1.42 1.421H1.42A1.421 1.421 0 0 1 0 7.106V1.42C0 .636.636 0 1.421 0h5.684zm9.474 0C17.364 0 18 .636 18 1.421v5.684c0 .785-.636 1.421-1.421 1.421h-5.684a1.421 1.421 0 0 1-1.421-1.42V1.42C9.474.636 10.11 0 10.894 0h5.685z"
        id={`${id}-a`}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path
        d="M7.105 9.474c.785 0 1.421.636 1.421 1.42v5.685c0 .785-.636 1.421-1.42 1.421H1.42A1.421 1.421 0 0 1 0 16.579v-5.684c0-.785.636-1.421 1.421-1.421h5.684zm9.474 0c.785 0 1.421.636 1.421 1.42v5.685c0 .785-.636 1.421-1.421 1.421h-5.684a1.421 1.421 0 0 1-1.421-1.421v-5.684c0-.785.636-1.421 1.42-1.421h5.685zM7.105 0c.785 0 1.421.636 1.421 1.421v5.684c0 .785-.636 1.421-1.42 1.421H1.42A1.421 1.421 0 0 1 0 7.106V1.42C0 .636.636 0 1.421 0h5.684zm9.474 0C17.364 0 18 .636 18 1.421v5.684c0 .785-.636 1.421-1.421 1.421h-5.684a1.421 1.421 0 0 1-1.421-1.42V1.42C9.474.636 10.11 0 10.894 0h5.685z"
        stroke={color}
        strokeWidth="2"
        mask={`url(#${id}-b)`}
      />
    </g>
  </svg>
);

DoubleColumnGrid.propTypes = propTypes;

export default DoubleColumnGrid;
